export function BrandLogo({ size = "md", className = "" }) {
  const s = size === "lg"
    ? { dr: "text-3xl", g: "text-5xl", pad: "px-5 py-2.5", rule: "h-[4px]" }
    : { dr: "text-[26px]", g: "text-[30px]", pad: "px-3 py-1.5", rule: "h-[3px]" };
  return (
    <span className={`dg-plate inline-flex items-end leading-none select-none rounded-lg bg-[#F4F6FA] ${s.pad} ${className}`} aria-label="Dr.Gadget" data-testid="brand-wordmark">
      <span className={`dg-wordmark-dr text-[#B8922E] ${s.dr}`}>Dr.</span>
      <span className="relative inline-block">
        <span className={`dg-wordmark-gadget text-[#182543] ${s.g}`}>Gadget</span>
        <span className={`absolute left-0 right-0 -bottom-0.5 ${s.rule} bg-[#182543] rounded-full`} />
      </span>
    </span>
  );
}
